import NavLink from 'components/shared/NavLink/NavLink';
import { NavContentLinkProps } from './types';
import { MainNavLinkSize } from 'types/constants';
import { cn } from 'utils/styles';
import { generateNavId } from 'components/MainNav/utils';

export interface NavCoreButtonProps {
  linkContent: NavContentLinkProps;
}

const NavCoreLinkHorizontal = ({ linkContent }: NavCoreButtonProps) => {
  const { linkSize, link } = linkContent;
  const linkId = generateNavId(link);

  const sharedStyles = cn(
    {
      'text-heading-sm leading-none': linkSize === MainNavLinkSize.Small,
      'text-body-saans leading-1.4 font-medium h-5': linkSize === MainNavLinkSize.Small,
    },
    'active:scale-none',
  );

  return (
    <NavLink
      id={linkId}
      level={0}
      className={cn(sharedStyles, 'hover:text-fern focus:text-fern h-full font-sans font-semibold')}
      href={link?.url}
      internalPage={link?.internalPage}
      sys={link?.sys}>
      {link.label}
    </NavLink>
  );
};

export default NavCoreLinkHorizontal;
